import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Toast from "vue-toastification";
import { useToast } from "vue-toastification";
import format from 'date-fns/format';
import { ptBR } from 'date-fns/locale';
import "vue-toastification/dist/index.css";
import 'tw-elements';
import './icons';
//import DisableDevtool from 'disable-devtool';
import { createPinia, setActivePinia } from 'pinia'


// if(process.env.NODE_ENV === 'production') {
//   DisableDevtool({
//     url: process.env.MIX_APP_URL + '/404'
//   });
// }

const pinia = createPinia()
setActivePinia(pinia)

const toast = useToast();
InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - ah.life` : 'ah.life',
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) });

    app.config.globalProperties.$toast = toast;

    app.config.globalProperties.$filters = {
      formatDate(value, type) {
        if(typeof(value) == "undefined" || value == null)
          return '';

        if(typeof(type) != "string")
          type = 'dd/MM/yyyy';

        if(typeof(value) != "object")
          value = new Date(value.replace(/-/g, '/'));

        return format(value, type, { locale: ptBR });
      },
      formatDateTime(value, type) {
        if(typeof(value) == "undefined" || value == null) {
          return '';
        }
        if(typeof(type) != "string") {
          type = 'dd/MM/yyyy HH:mm';
        }
        if(typeof(value) != "object") {
          value = new Date(value);
        }
        return format(value, type, { locale: ptBR });
      },
      allowedChars(word, numbers, email, specials, space) {
        let allowed = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        allowed += 'abcdefghijklmnopqrstuvwxyz';
        if(space === true){
          allowed += ' ';
        }
        if(numbers === true){
          allowed += '0123456789';
        }
        if(email === true){
          allowed += '-_@.';
        }
        if(specials === true){
          allowed += '-';
        }
        let newWord = '';
        let char = '';
        for(let i=0;i<word.length;i++) {
          char = word.substr(i,1).toString();
          try{
            if(char !== '$'){
              if (allowed.indexOf(char) >= 0) {
                newWord += char;
              }
            }
          }catch(err) {}
        }
        return newWord.replace(/( )+/g, ' ');
      },
      capitalize(name) {
        const capitalizedFirst = name[0].toUpperCase();
        const rest = name.slice(1);

        return capitalizedFirst + rest;
      },
    }

    app.component('font-awesome-icon', FontAwesomeIcon)
    .use(plugin)
    .use(Toast)
    .use(pinia)    
    .mount(el);
  },
})
